import { ComponentStyleConfig, theme as baseTheme } from '@chakra-ui/theme'

import { primaryColor } from '../foundations/primaryColor'

const { modal: { bgColorContent } } = primaryColor

export const Alert: ComponentStyleConfig = {
  baseStyle: {
    ...baseTheme.components.Alert.baseStyle,
    title: {
      lineHeight: 1,
      fontSize: 'md',
      fontWeight: 'normal',
      fontFamily: baseTheme.fonts.body,
      marginEnd: 2,
    },
    description: {
      lineHeight: 1,
      fontSize: 'sm',
      fontWeight: 'normal',
      fontFamily: baseTheme.fonts.body
    },
  },
  // Two sizes: sm and md
  sizes: {
    sm: {
      fontSize: 'sm',
      px: 4, // <-- px is short for paddingLeft and paddingRight
      py: 3, // <-- py is short for paddingTop and paddingBottom
    },
    md: {
      fontSize: 'md',
      px: 6, // <-- these values are tokens from the design system
      py: 4, // <-- these values are tokens from the design system
    },
  },
  variants: {
    'left-accent': props => ({
      ...baseTheme.components.Alert.variants['left-accent'](props),
      container: {
        bg: bgColorContent,
        borderStartColor: props.colorMode === 'dark' ? `${props.colorScheme}.500` : `${props.colorScheme}.500`,
      },
      icon: {
        color: props.colorMode === 'dark' ? `${props.colorScheme}.500` : `${props.colorScheme}.500`,
      },
    })
  },
  // The default size and variant values
  defaultProps: {
    size: 'md',
    variant: 'left-accent'
  },
}
